import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageDropdown from './LanguageDropdown';
import './Header.css';
import icon from './icons/arrow_drop_down_16dp.svg';
//import RevampBanner from "./announcement/RevampBanner";
import useLocalStorage from './useLocalStorage';


const Header = () => {
  const { t } = useTranslation();

  //Show the banner until 2025-07-31
  const bannerDisplayUntilDate = new Date("2025-08-01");
  const today = new Date(); // Gets today's date

  const [showSubmenu, setShowSubmenu] = useState(false);

  //Default of whether to showNewWebsiteBanner
  //Default value is to show until the bannerDisplayUntilDate
  const [showBanner, setShowBanner] = useLocalStorage('showNewWebsiteBanner', bannerDisplayUntilDate > today);
  

  return (
      <header className={showBanner ? 'with-banner' : ''}>

      
      {
        //No need to show banner 2025-08-15
        //showBanner && ( 
        //  <RevampBanner onDismiss={() => setShowBanner(false)} />
        //)
      }

        <nav>
          <div className="nav-links">
            <Link to="/">{t('common.nav.home')}</Link>
            <a 
              className="nav-item-with-submenu"
              onMouseLeave={() => setShowSubmenu(false)}
              onClick={() => setShowSubmenu(!showSubmenu)}
              aria-haspopup="true"
            >
              <span className="main-link">
                <span style={{verticalAlign: "top"}}
                >
                  {t('common.nav.setup')}
                </span>
                <img src={icon} alt={t('common.lang')} style={{verticalAlign: "top"}}/>
              </span>

              {showSubmenu && (
                <div className="submenu">
                  <Link onClick={() => setShowSubmenu(false)} to="/setup-v2">{t('common.versions.current_google_sheets')}</Link>
                  <Link onClick={() => setShowSubmenu(false)} to="/setup-v2-msexcel">{t('common.versions.current_ms_excel')}</Link>
                  <Link onClick={() => setShowSubmenu(false)} to="/setup-legacy">{t('common.versions.legacy_google_sheets')}</Link>
                </div>
              )}
            </a>
            
            <Link to="/privacy">{t('common.nav.privacy')}</Link>
          </div>
          <LanguageDropdown />
        </nav>

      </header>
  );
};

export default Header;